import { createContext, useContext } from 'react'

import { SelectionPublicationContextProps } from './SelectionPublicationContext.types'

export const SelectionPublicationContext = createContext<SelectionPublicationContextProps | undefined>(undefined)

export const useSelectionPublicationContext = () => {
  const context = useContext(SelectionPublicationContext)
  if (!context) {
    throw new Error('useSelection must be used within a SelectionProvider')
  }
  return context
}
